import React from "react";

const CustomerPricing = ({
  customerForm,
  handleChange,
  validationErrors,
  customerId = "",
}) => {
  return <div className="customer-pricing">Financial Information</div>;
};

export default CustomerPricing;
